export const reportLeftNavWidth = 280;
export const reportLeftNavNarrowWidth = 260;
